<fa-icon [icon]="icon" [matTooltip]="tooltip" [matTooltipShowDelay]="0" size="lg"></fa-icon>
